import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

const useExecuteGoogleRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  return executeRecaptcha
}

export default useExecuteGoogleRecaptcha
